module.exports = __webpack_public_path__ + "static/img/DSC_2705.98ad9dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2705.jpg
// module id = 281
// module chunks = 0